import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ReschedulePayment from '../components/Invoice/ReschedulePayment';
import { rescheduleCancelSuccess } from '../actions/invoiceVendorAction';

function mapStateToProps(state) {
  return {
    rescheduleSuccess: state.Invoice.rescheduleSuccess || false,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ rescheduleCancelSuccess }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ReschedulePayment);
